import React, { useEffect, useState } from "react";
import { Alert, Button, Form } from "reactstrap";

// components
import StartButtons from "./StartButtons";
import InputSection from "./InputSection";
import EndButtons from "./EndButtons";
import MoreMenu from "./MoreMenu";
import Reply from "./Reply";
import { IMessagesTypes, QuickReply } from "../../../../types/message";

import MoreMenuTemplates from "./moreMenuTemplates";
import { useMessages } from "../../../../context/MessagesContext";
import { useAuth } from "../../../../context/AuthContext";
import QuickReplyList from "../QuickReplyList";
import { useQuickReply } from "../../../../context/QuickRepliesContext";
import { IContactDetailsTypes, IProfileDetailsTypes } from "../../../../types/profile";


interface IndexProps {
  onSendMessage: (data: any) => void;
  replyData: null | IMessagesTypes | undefined;
  onSetReplyData: (reply: null | IMessagesTypes) => void;
  chatUserDetails: IContactDetailsTypes | null;
  isBlocked: boolean;
  canOpenChat: boolean;
  canSendFreeText: boolean;
}

const Index = ({
  onSendMessage,
  replyData,
  onSetReplyData,
  chatUserDetails,
  isBlocked,
  canOpenChat,
  canSendFreeText,
}: IndexProps) => {

  const { sendTemplateMessage, sendAudioMessage, sendAudioTemplateMessage } = useMessages();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenTemplate, setIsOpenTemplate] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [text, setText] = useState<null | string>("");

  const [showQuickReply, setShowQuickReply] = useState(false);
  const [quickSearch, setQuickSearch] = useState("");

  const { loadAllQuick, quickReply, loading } = useQuickReply();
  const [quickReplies, setQuickReplies] = useState<QuickReply[]>([]);
  const { user } = useAuth();
  const safeUser = chatUserDetails;


  // console.log('chatUserDetails', chatUserDetails);

  const isBlockedByMeta = isBlocked;
  const isOpenedByOtherUser = !canOpenChat;
  const isOutOf24hWindow = !safeUser?.basicDetails?.in24hWindow;

  // console.log('[input] isBlockedByMeta', isBlockedByMeta);
  // console.log('[input] canOpenChat', canOpenChat);
  // console.log('[input] isOpenedByOtherUser', isOpenedByOtherUser);
  // console.log('[input] isOutOf24hWindow', isOutOf24hWindow);

  useEffect(() => {
    loadAllQuick();
  }, []);

  useEffect(() => {
    setQuickReplies(quickReply);
  }, [quickReply]);

  const onToggle = () => {
    setIsOpen(!isOpen);
    setemojiArray(true);
  };

  const onToggleTemplate = () => {
    setIsOpenTemplate(!isOpenTemplate);
  };

  const onSelectTemplate = async (templateId: string) => {
    if (!user?.id) return;
    if (!safeUser?.basicDetails.id) return;

    // 🚫 REGRA 1: Bloqueio por data
    if (safeUser?.basicDetails.blockedMessage) {
      const now = new Date();
      const blockedUntil = new Date(safeUser?.basicDetails.blockedMessage);

      if (blockedUntil > now) {
        console.log(
          "🚫Nao enviado, contato bloqueado até:",
          blockedUntil.toISOString()
        );
        // ⛔ Interrompe aqui — NÃO chama onSelectTemplate
        return;
      }
    }

    //Nao pode enviar, sessão aberta com outro atendente
    if (!canOpenChat) {
      console.log(
        "🚫Nao enviado, contato com sessão com outro atendente"
      );
      // ⛔ Interrompe aqui — NÃO chama onSelectTemplate
      return;
    }



    setIsOpenTemplate(!isOpenTemplate);
    // console.log('[index] [onSelectTemplate] template', templateId)
    await sendTemplateMessage({
      'idUser': user.id,
      'idContact': safeUser?.basicDetails.id,
      'templateMetaId': templateId
    });

  };

  const onSendAudioTemplate = async (quickRepliesId: number) => {
    if (!user?.id) return;
    if (!safeUser?.basicDetails.id) return;

    // 🚫 REGRA 1: Bloqueio por data
    if (safeUser?.basicDetails.blockedMessage) {
      const now = new Date();
      const blockedUntil = new Date(safeUser?.basicDetails.blockedMessage);

      if (blockedUntil > now) {
        console.log(
          "🚫Nao enviado, contato bloqueado até:",
          blockedUntil.toISOString()
        );
        // ⛔ Interrompe aqui — NÃO chama onSelectTemplate
        return;
      }
    }

    //Nao pode enviar, sessão aberta com outro atendente
    if (!canOpenChat) {
      console.log(
        "🚫Nao enviado, contato com sessão com outro atendente"
      );
      // ⛔ Interrompe aqui — NÃO chama onSelectTemplate
      return;
    }

    // setIsOpenTemplate(!isOpenTemplate);
    setIsOpen(!isOpen);

    // console.log('[index] [onSelectTemplate] template', templateId)
    await sendAudioTemplateMessage({
      'idUser': user.id,
      'idContact': safeUser?.basicDetails.id,
      'idQuickReplies': quickRepliesId
    });

  };

  const onChangeText = (value: string) => {
    setText(value);

    const match = value.match(/(^|\s)\/(\w*)$/);

    if (match) {
      setShowQuickReply(true);
      setQuickSearch(match[2] || "");
    } else {
      setShowQuickReply(false);
      setQuickSearch("");
    }
  };

  const onSelectQuickReply = (reply: string) => {
    setText(prev => {
      if (!prev) return reply;

      return prev
        .replace(/(^|\s)\/\w*$/, `$1${reply}`)
        .trimStart();
    });

    setShowQuickReply(false);
    setQuickSearch("");
  };

  /*
  images
  */
  const [images, setImages] = useState<Array<any> | null | undefined>();
  const onSelectImages = (images: Array<any>) => {
    setImages(images);
  };

  /*
  files
  */
  const [files, setFiles] = useState<Array<any> | null | undefined>();
  const onSelectFiles = (files: Array<any>) => {
    setFiles(files);
  };

  useEffect(() => {
    if (text || images || files) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [text, images, files]);

  // emoji picker   
  const [emojiArray, setemojiArray] = useState<any>("");
  const [emojiTextArray, setEmojiTextArray] = useState<string[]>([]);
  const [emojiPicker, setemojiPicker] = useState<boolean>(false);

  // const [messageContact, setmessageContact] = useState<string>("");

  const onEmojiClick = (event: any) => {
    setEmojiTextArray([...emojiTextArray, event.emoji]);
    setText(text + event.emoji);
    console.log('[Index][onEmojiClick]', event.emoji)
  };

  // Submit Message
  const onSubmit = () => {

    // -------- VALIDAÇÃO --------
    const isTextValid = text && text.trim().length > 0;
    const hasImages = images && images.length > 0;
    const hasFiles = files && files.length > 0;

    // 🔥 Se nao tiver NADA pra enviar → não envia
    if (!isTextValid && !hasImages && !hasFiles) {
      return; // simplesmente não envia
    }

    //Nao pode enviar, sessão aberta com outro atendente
    if (!canOpenChat) {
      console.log(
        "🚫Nao enviado, contato com sessão com outro atendente"
      );
      // ⛔ Interrompe aqui — NÃO chama onSelectTemplate
      return;
    }


    let data: any = {};
    if (text) {
      data["text"] = text;
    }
    if (images && images.length) {
      const imgs = (images || []).map((i: any, key: number) => {
        const src = URL.createObjectURL(i);
        return {
          id: key + 1,
          downloadLink: src,
        };
      });
      data["image"] = imgs;
    }

    if (files && files.length) {
      const fs = (files || []).map((f: any, key: number) => {
        const src = URL.createObjectURL(f);
        return {
          id: key + 1,
          name: f.name,
          downloadLink: src,
          desc: f.size,
        };
      });
      data["attachments"] = fs;
    }

    setText("");
    setImages(null);
    setFiles(null);
    setemojiPicker(false);
    onSendMessage(data);
  };

  const onClearMedia = () => {
    setImages(null);
    setFiles(null);
  };

  /* ---------------- BLOB ---------------- */
  const base64ToBlob = (base64: string, mime: string): Blob => {
    const byteCharacters = atob(base64.split(",")[1]);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    return new Blob([new Uint8Array(byteNumbers)], { type: mime });
  };

  /* ---------------- AUDIO FILE ---------------- */
  //1668_1961173558137295_20260130_091521.ogg
  //⚠️ Ajuste o MIME se seu backend exigir audio/ogg ou audio/mpeg
  const createAudioFile = (base64: string): File => {
    var mimeType = "audio/webm"; //"audio/ogg"

    const blob = base64ToBlob(base64, mimeType);
    return new File([blob], `audio-${Date.now()}.webm`, {
      type: mimeType, // "audio/ogg",
    });
  };

  const buildAudioFormData = (
    base64: string,
    idUser: number,
    idContact: number
  ): FormData => {
    const file = createAudioFile(base64);
    console.log('buildAudioFormData', file)

    const formData = new FormData();
    formData.append("IdUser", idUser.toString());
    formData.append("IdContact", idContact.toString());
    formData.append("Caption", "audio");
    formData.append('file', file, file.name.toString());

    //formData.append("File", file);

    console.log('[buildAudioFormData][formData]', formData)
    return formData;
  };

  const onAudioRecorded = async (base64: string) => {
    if (!user?.id) return;
    if (!safeUser?.basicDetails.id) return;

    const formData = buildAudioFormData(
      base64,
      user.id,
      safeUser?.basicDetails.id
    );

    // for (const pair of formData.entries()) {
    //   console.log(pair[0], pair[1]);
    // }

    formData.forEach((value, key) => {
      console.log(key, value);
    });

    try {
      await sendAudioMessage(formData);
      console.log("🎤 Áudio enviado com sucesso");
    } catch (err) {
      console.error("Erro ao enviar áudio", err);
    }
  };

  return (
    <div className="chat-input-section p-3 p-lg-4">
      <Form
        id="chatinput-form"
        onSubmit={(e: any) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        {!isOpenedByOtherUser && canSendFreeText ? (
          <div className="row g-0 align-items-center">
            <div className="col-auto">
              <StartButtons
                onToggle={onToggle}
                onToggleTemplate={onToggleTemplate}
                onEmojiClick={onEmojiClick}
                setemojiPicker={setemojiPicker}
                emojiPicker={emojiPicker}
              />
            </div>
            <div className="col">
              <InputSection value={text} onChange={onChangeText} onSubmit={onSubmit} />
            </div>
            <div className="col-auto">
              <EndButtons onSubmit={onSubmit} disabled={disabled} onAudioRecorded={onAudioRecorded} />
            </div>
          </div>
        ) : (
          <div className="row g-0 align-items-center">
            <div className="col">
              <div className="alert alert-warning d-flex justify-content-between align-items-center">

                <div>
                  {isBlockedByMeta && (
                    <>
                      🚫 Contato bloqueado até{" "}
                      <strong>
                        {new Date(safeUser?.basicDetails?.blockedMessage as string).toLocaleString("pt-BR")}
                      </strong>
                      <small>
                        {" "}Não é possível enviar mensagens ou templates até o cliente iniciar
                        uma nova conversa.
                      </small>
                    </>
                  )}

                  {isOpenedByOtherUser && (
                    <>
                      🚫 Contato com sessão aberta com outro atendente
                      <small>
                        {" "}Aguarde a finalização da sessão atual para assumir o atendimento.
                      </small>
                    </>
                  )}

                  {!isBlockedByMeta && !isOpenedByOtherUser && isOutOf24hWindow && (
                    <>
                      ⚠️ Conversa fora da janela de 24h.
                      <small>
                        {" "}É obrigatório enviar um template aprovado.
                      </small>
                    </>
                  )}
                </div>

                {!isBlockedByMeta && !isOpenedByOtherUser && isOutOf24hWindow && (
                  <>
                    <Button
                      color={isOpenTemplate ? "secondary" : "primary"}
                      onClick={() => setIsOpenTemplate(!isOpenTemplate)}
                      // disabled={isBlocked} // 🔒 bloqueia botão
                      className={`btn ${isOpenTemplate ? "btn-secondary" : "btn-primary"
                        } btn-sm chat-send waves-effect waves-light`}
                    >
                      <i className="bx bxs-send align-middle me-2"></i>
                      {isOpenTemplate ? "Ocultar template" : "Enviar template"}
                    </Button>
                  </>
                )}


              </div>
            </div>

          </div>
        )}


      </Form>
      {(images && images.length) || (files && files.length) ? (
        <Alert
          isOpen={true}
          toggle={onClearMedia}
          color="secondary"
          className="alert-dismiss-custom 
        rounded-pill font-size-12 mb-1 selected-media"
          closeClassName="selected-media-close"
        >
          <p className="me-2 mb-0">
            {images && !files && ` You have selected ${images.length} images`}
            {files && !images && ` You have selected ${files.length} files`}
            {files &&
              images &&
              ` You have selected ${files.length} files & ${images.length} images.`}
          </p>
        </Alert>
      ) : null}

      <MoreMenu
        isOpen={isOpen}
        onSelectImages={onSelectImages}
        onSelectFiles={onSelectFiles}
        onSendAudio={onSendAudioTemplate}
        onToggle={onToggle}
      />

      <MoreMenuTemplates
        isOpen={isOpenTemplate}
        blockedMessage={safeUser?.basicDetails.blockedMessage as string}
        onSelectTemplate={onSelectTemplate}
      />

      <Reply
        reply={replyData}
        onSetReplyData={onSetReplyData}
        chatUserDetails={chatUserDetails}
      />

      <QuickReplyList
        visible={showQuickReply}
        search={quickSearch}
        items={quickReplies}
        onSelect={onSelectQuickReply}
      />

    </div>
  );
};

export default Index;
